import { Col, Row, Button } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import ComponentsBreadcrumb from "../../../layout/componentsBreadcrumb";
import { viewTransactionDetailes } from "./api";
import { connect } from "react-redux";
import moment from "moment/moment";
import Loader from "../../../shared/loader";
import AppRow from "../../../shared/appRow";
import AppAlert from "../../../shared/appAlert";
import AppText from "../../../shared/appText";
import CopyToClipboard from "react-copy-to-clipboard";
import { isErrorDispaly } from "../../../shared/validationsAndExceptions/apiExceptions";

const breadCrumbList = [
  { id: "1", bname: "Payment Artha",url : '/dashboard' },
  { id: '2', bname: 'Transactions' ,url : '/viewtransactions'},
  { id: '3', bname: 'Transaction Details' }
];

const TransactionDetails = (props) => {
  const [loader, setLoader] = useState(false);
  const [transaction, settransaction] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const transactionDate = transaction?.txDate ? moment.utc(transaction.txDate).local().format("DD/MM/YYYY hh:mm:ss A") : transaction?.txDate;

  const params = useParams();
  useEffect(() => {
    if(params?.id){
      viewTransaction();
    }
  }, [params?.id])
  const viewTransaction = async () => {
    setLoader(true)
    const response = await viewTransactionDetailes(params?.id);
    if (response.ok) {
      setLoader(false)
      settransaction(response.data);
      setErrorMessage(null)
    } else {
      setLoader(false)
      setErrorMessage(isErrorDispaly(response.data));
    }
  }
  const history = useHistory()
  const handleCancel = () => {
    history.push(`/viewtransactions`);
  }
  const renderTxRef = (transactionData) => {
    const txRef = transactionData?.txRef;
    const explorerLink = transactionData?.explorer;
    if (txRef) {
      return (
        <div className="summary-text text-link">
          <span 
            className="c-pointer"
            onClick={() => window.open(explorerLink + txRef)}>
            {txRef.substring(0, 4) + "...." + txRef.slice(txRef.length - 4)}
          </span>
           <CopyToClipboard text={txRef} options={{ format: 'text/plain' }}>
            <AppText copyable={{ tooltips: ['Copy', 'Copied'] }} className="summary-text"></AppText>
          </CopyToClipboard>
        </div>
      );
    } else {
      return <div className="summary-text">--</div>;
    }
  };
  return (<>
    <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
    {/* <span className="card-title card-head"> Transaction Details  </span> */}
    <AppRow>
      {errorMessage && (
        <div className="alert-flex" style={{ width: "100%" }}>
          <AppAlert
            className="w-100 "
            type="warning"
            description={errorMessage}
            showIcon
          />
          <span className="icon sm alert-close" onClick={() => setErrorMessage(null)}></span>
        </div>
      )}</AppRow>

    {loader ? <Loader /> : <div className="layout-bg right-panel panel-bg tracnsaction-details">
      <div className='trans-card'>

      <div className="d-flex align-items-center">
                  <span className="icon lg btn-arrow-back c-pointer" onClick={handleCancel}></span>
                  <span className="card-title card-head">Transaction Details  </span>
                </div>
        <Row gutter={[4, 4]} className='summary-content tx-space transaction-summary mt-16'>

          <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Transaction Date</div>
              <div className=" summary-text">{transactionDate}</div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Transaction Type</div>
              <div className=" summary-text">{transaction?.txType}</div>
            </div>
          </Col>


          <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Transaction Wallet</div>
              <div className=" summary-text">{transaction?.txWallet}</div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Network</div>
              <div className=" summary-text">{transaction?.network}</div>
            </div>
          </Col>
          {transaction?.txType !== "Withdraw" && <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Hash</div>
              {renderTxRef(transaction)}
            </div>
          </Col>}
         {transaction?.txType !== "Withdraw" && <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Deposit Amount</div>
              <div className=" summary-text">{parseFloat(transaction?.volume).toLocaleString(undefined, { maximumFractionDigits: 20 }) || "--"}</div>
            </div>
          </Col>}
          {transaction?.txType === "Withdraw" && <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Withdraw Amount</div>
              <div className=" summary-text">{parseFloat(transaction?.volume).toLocaleString(undefined, { maximumFractionDigits: 20 }) || "--"}</div>
            </div>
          </Col>}
          {/* <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Fee</div>
              <div className=" summary-text">{parseFloat(transaction?.commission).toLocaleString(undefined, { maximumFractionDigits: 20 }) || "--"}</div>
            </div>
          </Col> */}

          <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Net Amount</div>
              <div className=" summary-text">{transaction?.amount}</div>
            </div>
          </Col>

          {transaction?.txType !== "Withdraw" && <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Sender's Name</div>
              <div className=" summary-text">{transaction?.createdBy}</div>
            </div>
          </Col>}

          <Col xs={24} sm={24} md={24} lg={24} xxl={24} >
            <div className="summary-list-item">
              <div className=" summary-label">Status</div>
              <div className={`summary-text text-green`}>{transaction?.state}</div>
            </div>
          </Col>

        </Row>
        <div className="text-right mb-24">
          <Button className="outlined-btn payee-popup pop-btn mr-8" onClick={handleCancel} >
            Cancel
          </Button>

        </div>

      </div>
    </div>}
  </>
  )
}
const connectStateToProps = ({ userConfig }) => {
  return {
    userConfig: userConfig.userProfileInfo
  }
}
export default connect(connectStateToProps)(TransactionDetails);